import { ResponseBase } from '#models/db/response/response-base.model';

export const B2B_OFFERING = 'defaultB2BOffering';
export const IOS_B2B_OFFERING = 'iOSB2BOffering';

export interface UserRedemptionCode {
  /**
   * Indicates if user has a redeemed a B2B verification code.
   */
  userVerificationCode: boolean;
}

export type UserRedemptionCodeResponse = ResponseBase<UserRedemptionCode>;

export interface UserRedeemedCode {
  code: string;
  code_batch_id: string;
  created_at: string;
  id: string;
  is_active: boolean;
  redeemed_at: string | null;
  redeemed_by: string | null;
  redemption_status: RedemptionStatus;
  updated_at: string;
}

export type RedemptionStatus = 'unused' | 'redeemed';

export type PostCodeVerificationResponse = ResponseBase<UserRedeemedCode>;

export interface PostCodeVerificationRequest {
  redemption_code: string;
}
